import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

/**
 * App toaster — the React equivalent of Django's messages framework. Mounted
 * once in the shell. Uses the design tokens so success/error toasts match the
 * (accessible) palette.
 */
function Toaster(props: ToasterProps) {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          error:
            "group-[.toaster]:border-destructive/40 group-[.toaster]:text-destructive",
          success: "group-[.toaster]:text-success",
        },
      }}
      {...props}
    />
  );
}

export { Toaster, toast };
